import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id", "value", "name", "checked", "onChange"]
const _hoisted_2 = ["for"]

import {
    TextCustomizerOption,
} from '@/types/productServerApi';
import useProductDetailPage from '@/shared/product/details/useProductDetailPage';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMiniTabText',
  props: {
    id: null,
    options: null
  },
  setup(__props: any) {




const { updateSku } = useProductDetailPage();


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
    return (_openBlock(), _createElementBlock("div", {
      key: option.sku,
      class: "c-checkbox min-w-130 xl:min-w-160"
    }, [
      _createElementVNode("input", {
        id: option.sku,
        value: option.sku,
        name: __props.id,
        checked: option.selected,
        type: "radio",
        class: "c-checkbox__field",
        onChange: ($event: any) => (_unref(updateSku)(option.sku))
      }, null, 40, _hoisted_1),
      _createElementVNode("label", {
        for: option.sku,
        class: "c-checkbox__label-radio"
      }, [
        _createElementVNode("span", null, _toDisplayString(option.title), 1)
      ], 8, _hoisted_2)
    ]))
  }), 128))
}
}

})